import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";

import StandsList from "../references/stands/List";
import StandForm from "../references/stands/Form"
import StandKits from "../references/standkits/StandKits";
import * as constants from "../assets/constants";
import React from "react";
import {AdaptivityContext} from "../assets/constants";
import StandsApi from "../api/references/stands"
import {OfflineProvider} from "../contexts/OfflineContext";

class FragmentStands extends BaseComponent {
    constructor(props) {
        super(props)
        const state = {

            activePanelBrands: "panel_brands_list",
            current_brand: null,
            getImageEventName: "setImage",

            // Сохраняем состояние списка стендов при переключении панелей
            listState: null,
        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    // Callback для сохранения состояния списка
    saveListState = (listState) => {
        this.setState({ listState })
    }

    receiveMessage = (event) => {
        if (event.data.type !== undefined && event.data.type === 'setCurrentBrand') {
            console.log(event)

            this.setState({
                current_brand: event.data.value,
                activePanelBrands: event.data.value !== null ? 'panel_brands_item' : 'panel_brands_list'
            })

            return
        }
        if (event.data.type !== undefined && event.data.type === 'reloadCurrentBrand' && this.state.current_brand.id > 0) {
            StandsApi.getOne(this.state.current_brand.id).then(response => {
                const {data} = response

                if (data.id) {
                    this.setState({current_brand: data, activePanelBrands: 'panel_brands_item'})
                }
            })

            return
        }

    }

    render() {
        return <OfflineProvider>
            <View activePanel={this.state.activePanelBrands}>
                <Panel id="panel_brands_list">
                    <SplitLayout>
                        {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                        <SplitCol>
                            <StandsList 
                                current_user={this.props.current_user}
                                savedListState={this.state.listState}
                                onSaveListState={this.saveListState}
                            />
                        </SplitCol>
                        {!AdaptivityContext.isMobile &&
                            <SplitCol>

                            </SplitCol>}
                    </SplitLayout>
                </Panel>
                <Panel id="panel_brands_item">
                    <SplitLayout>
                        {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                        <SplitCol>
                            <StandForm
                                current_user={this.props.current_user}
                                item={this.state.current_brand}
                                base_url={this.state.base_url}
                                eventType="setCurrentBrand"
                                title_new="Новый стенд"
                                title="Стенд"
                                fields={
                                    {
                                        title: {
                                            required: true,
                                            title: 'Наименование',
                                            type: 'text'
                                        },
                                        is_competitor: {
                                            title: 'Стенд конкурента',
                                            type: 'checkbox'
                                        },
                                        deleted: {
                                            title: 'Запрет ввода',
                                            type: 'checkbox'
                                        },
                                        type_id: {
                                            required: true,
                                            title: 'Тип',
                                            type: 'select',
                                            options: constants.getEquipmentTypes()
                                        },
                                        group_id: {
                                            required: true,
                                            title: 'Товарная группа',
                                            type: 'select',
                                            options: constants.getEquipmentGroups()
                                        },
                                        trade_mark_id: {
                                            title: 'Торговая марка',
                                            nullValue: '',
                                            type: 'SelectObject',
                                            app: 'trademarks',
                                            act: 'getList',
                                            modal_title: 'Торговые марки'
                                        },

                                        parent_id: {
                                            title: 'Головной стенд',
                                            type: 'SelectObject',
                                            app: 'stands',
                                            act: 'getList',
                                            params: 'is_competitor=1&exclude_ids={self_id}',
                                            modal_title: 'Список стендов'
                                        }
                                    }
                                }
                                hideForm={() => this.setState({
                                    current_brand: null,
                                    activePanelBrands: 'panel_brands_list'
                                })}

                            />
                            {this.state.current_brand && this.state.current_brand.id > 0 && !Number(this.state.current_brand.is_competitor) &&
                                <StandKits stand={this.state.current_brand} current_user={this.props.current_user}/>}
                        </SplitCol>
                        {!AdaptivityContext.isMobile && <SplitCol>
                        </SplitCol>}
                    </SplitLayout>
                </Panel>

            </View>
        </OfflineProvider>
    }
}

export default FragmentStands
